import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

const TemplateStatus = ({ name, value, onChange }) => {
  const { t } = useTranslation();

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "选择状态" })}
      clearable
      options={[
        { id: 1, name: t({ defaultMessage: "启用" }) },
        { id: 2, name: t({ defaultMessage: "禁用" }) }
      ]}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

export default TemplateStatus;
